module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "max-width": "1100px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "coaching"
    }
  }, [_c('h1', [_vm._v("Keep connected with virtual meet-ups and one-to-one coaching")]), _vm._v(" "), _c('p', [_vm._v("Join weekly virtual meetups and stay connected with coaches and friends from around the globe.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "coachingCards"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('coaching-card', {
    staticStyle: {
      "min-height": "540px"
    },
    attrs: {
      "image": "https://res.cloudinary.com/grohealth/image/upload/v1610543180/Low%20Carb%20Program/UI-Assets/5fd1e9e75ac081c56b819597_evening-meetups-p-500.webp",
      "title": "Monday night meet up",
      "text": "Join our original Monday night meet up, hosted by our very own Health coaches. This meet up has been long-standing and is ideal for those who have been attending the meet ups for some time. It’s a great way to kickstart your week on a positive note and keep you feeling motivated. The Health coaches will be speaking to you about a different topic each week, followed by a good old catch up with your fellow members.",
      "list": ['Get support from your mentors', 'Meet others on the same journey'],
      "buttonText": "More about Monday meet ups",
      "buttonLink": "life/low-carb-programs-virtual-meet-up-monday-6pm"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('coaching-card', {
    attrs: {
      "image": "static/weighin.png",
      "title": "Wednesday Meet ups",
      "text": "If you are new to the Low Carb Program, then this is a must do meet up for you! On this meet up you can expect to hear your mentor cover topics for beginners, who are new to the program and low carb approach. It is also a great way to ask questions and meet with other members at a similar point of their journey to you.",
      "list": ['Get support from your mentors', 'Something else'],
      "buttonText": "More about Wednesday meet ups",
      "buttonLink": "life/low-carb-newbie-meet-up-wednesday-6pm"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "50"
    }
  }, [_c('coaching-card', {
    attrs: {
      "image": "https://res.cloudinary.com/grohealth/image/upload/v1612266366/Low%20Carb%20Program/UI-Assets/601907ca6ba8ee0341514d3a_antonia-remote-p-500.webp",
      "title": "Low Carb Program daily drop in sessions",
      "text": "You can drop in and visit us at 11am any day of the working week. This is a great session to use if you are new to the Low Carb Program, unsure of where to get started or looking for some help on how to use the various features available.",
      "list": ['A chance to ask questions', 'Find support and motivation every day'],
      "buttonText": "More about Daily Drop-in Sessions",
      "buttonLink": "life/january-bootcamp-drop-in-sessions"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "supportCard"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "supportInfo"
  }, [_c('h2', [_vm._v("Need some one-to-one support?")]), _vm._v(" "), _c('p', [_vm._v("If you feel like you could do with some more personal support, or just prefer some privacy, then one-to-one coaching is for you.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Meet your personal health coach and mentor.")]), _vm._v(" "), _c('li', [_vm._v("Get help on how to make the most out of the Program.")]), _vm._v(" "), _c('li', [_vm._v("Create short and long-term goals to better your health.")]), _vm._v(" "), _c('li', [_vm._v("Receive support on how to tailor the low carb lifestyle for you.")])]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "label": "Purchase one-to-one coaching",
      "href": "https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "stepsCard"
  }, [_c('h2', [_vm._v("How it works")]), _vm._v(" "), _c('p', [_vm._v("Follow these three simple steps to book in with your health coach and start your journey to better health today.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "label": "Purchase one-to-one coaching",
      "href": "https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "marginBottom"
  }, [_vm._v("We currently host 2 meet-ups each week, with one-to-one time "), _c('a', {
    attrs: {
      "href": "https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching"
    }
  }, [_vm._v("available for purchase from our shop")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepList"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "stepNumber"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "stepText"
  }, [_c('p', [_vm._v("Purchase your Health Coaching session from the Low Carb Program Shop.")])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "stepNumber"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "stepText"
  }, [_c('p', [_vm._v("Use the link in the receipt email to book a coaching session with a coach of your choice. Choose the date and time to suit you.")])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "stepNumber"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "stepText"
  }, [_c('p', [_vm._v("Join the 30-minute session using your phone or computer using Zoom.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ffc3317","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Coaching/Coaching.vue
// module id = 3255
// module chunks = 1